
import { useState, useCallback } from 'react';
import { OrderWithCustomer } from '../types/orderTypes';

export const useOrderSelection = () => {
  const [selectedOrders, setSelectedOrders] = useState<string[]>([]);
  const [editingOrderId, setEditingOrderId] = useState<string | null>(null);
  const [isAdding, setIsAdding] = useState(false);

  const toggleOrderSelection = useCallback((id: string) => {
    setSelectedOrders(prev => 
      prev.includes(id) 
        ? prev.filter(orderId => orderId !== id) 
        : [...prev, id]
    );
  }, []);

  const toggleSelectAll = useCallback((orders?: OrderWithCustomer[]) => {
    if (!orders || orders.length === 0) {
      setSelectedOrders([]);
      return;
    }
    
    setSelectedOrders(prev => {
      if (orders.every(order => prev.includes(order.id))) {
        return [];
      } else {
        return orders.map(order => order.id);
      }
    });
  }, []);

  const areAllSelected = useCallback((orders?: OrderWithCustomer[]) => {
    if (!orders || orders.length === 0) return false;
    return orders.every(order => selectedOrders.includes(order.id));
  }, [selectedOrders]);

  const handleEditOrder = useCallback((id: string) => {
    setEditingOrderId(id);
  }, []);

  const handleBackToOrders = useCallback(() => {
    setEditingOrderId(null);
    setIsAdding(false);
  }, []);

  return {
    selectedOrders,
    editingOrderId,
    isAdding,
    setIsAdding,
    toggleOrderSelection,
    toggleSelectAll,
    areAllSelected,
    handleEditOrder,
    handleBackToOrders
  };
};
